import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { auth } from '@urgent/router/middleware/auth'
import { guest } from '@urgent/router/middleware/guest'
import { ERouterList } from '@urgent/router/constants/router-list'
import middlewareGuard from '@shared/utils/middleware-guard'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: ERouterList.HOME,
    component: () => import('@urgent/pages/index.vue'),
  },
  {
    path: '/notready',
    name: ERouterList.NOT_READY,
    component: () => import('@urgent/pages/notready.vue'),
  },
  {
    path: '/:qrCode',
    name: ERouterList.QR_CODE,
    component: () => import('@urgent/pages/_qrCode/index.vue'),
  },
  {
    path: '/preview',
    name: ERouterList.GUEST_MEETING_PREVIEW,
    component: () => import('@urgent/pages/preview.vue'),
    meta: {
      middleware: [guest],
    },
  },
  {
    path: '/meeting',
    name: ERouterList.GUEST_MEETING,
    component: () => import('@urgent/pages/meeting.vue'),
    meta: {
      middleware: [guest],
    },
  },
  {
    path: '/:qrCode/:visitId/visit-information',
    name: ERouterList.VISIT_INFORMATION,
    component: () => import('@urgent/pages/_qrCode/_visitId/visit-information.vue'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/:qrCode/:visitId/feedback',
    name: ERouterList.FEEDBACK,
    component: () => import('@urgent/pages/_qrCode/_visitId/feedback.vue'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/:qrCode/:visitId/summary',
    name: ERouterList.SUMMARY,
    component: () => import('@urgent/pages/_qrCode/_visitId/summary.vue'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/:qrCode/:visitId/preview',
    name: ERouterList.MEETING_PREVIEW,
    component: () => import('@urgent/pages/_qrCode/_visitId/preview.vue'),
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/:qrCode/:visitId/meeting',
    name: ERouterList.MEETING,
    component: () => import('@urgent/pages/_qrCode/_visitId/meeting.vue'),
    meta: {
      middleware: [auth],
    },
  },
]

if (import.meta.env.DEV) {
  routes.push({
    path: '/stylesheets',
    name: ERouterList.STYLESHEETS,
    component: () => import('@urgent/pages/stylesheets.vue'),
  })
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
})
middlewareGuard(router)

router.onError(error => {
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    location.reload()
  }
})

export default router
